import React from 'react';
import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined'; 
import ClearIcon from '@mui/icons-material/Clear';
import { theme } from '../../../theme';

const SearchComponent = ({
    searchQuery,
    setSearchQuery,
    // onSearchClick,
    placeholder = "Search events...",
}) => {
    return (
        <Box sx={{ mt: 2, mb: 2, display: 'flex', justifyContent: 'center' }}>
            <TextField
                variant="outlined"
                size="small"
                fullWidth
                placeholder={placeholder}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputProps={{
                    sx: { borderRadius: 4, color: theme.colors.events.secondary },
                    endAdornment: (
                        <InputAdornment position="end">
                            {searchQuery ? (
                              <IconButton
                                size="small"
                                onClick={() => setSearchQuery('')}
                                sx={{ color: theme.colors.events.secondary }}
                              >
                                    <ClearIcon/>
                              </IconButton>
                            ) : (
                              <IconButton
                                size="small"
                                onClick={() => setSearchQuery(searchQuery)}
                                sx={{ color: theme.colors.events.secondary }}
                              >
                                <SearchIcon />
                              </IconButton>
                            )}
                            {/* <IconButton
                                size="small"
                                onClick={() => console.log("Filter clicked")}
                                sx={{ color: theme.colors.events.secondary }}
                            >
                                <FilterAltOutlinedIcon />
                            </IconButton> */}
                        </InputAdornment>
                    ),
                }}
                sx={{
                    width: 400,
                    "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                            borderColor: theme.colors.events.secondary,
                        },
                        "&:hover fieldset": {
                            borderColor: theme.colors.events.secondary,
                        },
                        "&.Mui-focused fieldset": {
                            borderColor: theme.colors.events.secondary,
                        },
                    },
                }}
            />
        </Box>
    );
};

export default SearchComponent;